import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ExchangeDollar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 15.103A8.001 8.001 0 008.03 5.053l-.992-1.737A9.996 9.996 0 0117 3.34c4.49 2.592 6.21 8.142 4.117 12.77l1.342.774-4.165 2.214-.165-4.714 1.246.719zM4.625 8.897a8.001 8.001 0 0011.345 10.05l.992 1.737A9.996 9.996 0 017 20.66C2.51 18.068.79 12.518 2.883 7.89L1.54 7.117l4.165-2.214.165 4.714-1.246-.719zM8.5 14H14a.5.5 0 100-1h-4a2.5 2.5 0 110-5h1V7h2v1h2.5v2H10a.5.5 0 100 1h4a2.5 2.5 0 110 5h-1v1h-2v-1H8.5v-2z"
  }));
});
ExchangeDollar.displayName = 'ExchangeDollar';
export var ExchangeDollarDimensions = {
  height: 24,
  width: 24
};